import { MANUALLY_SELECTED_ORGANIZATION } from '@backoffice-frontend/common'
import { useLocalStorage } from '@backoffice-frontend/hooks'
import { Input } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

export const SubdomainInput = ({
  onSubdomainChange,
}: {
  onSubdomainChange: () => void
}) => {
  const { t } = useTranslation()
  const [subdomain, setSubdomain] = useLocalStorage(
    MANUALLY_SELECTED_ORGANIZATION,
    'moia',
  )

  const handleSubdomainChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSubdomain(event.target.value)
  }

  const handleBlur = () => {
    onSubdomainChange()
  }

  return (
    <Input
      aria-label={t('loginView_subdomainInput')}
      placeholder={t('loginView_subdomainInput_placeholder')}
      size="compact"
      value={subdomain}
      onChange={handleSubdomainChange}
      onBlur={handleBlur}
    />
  )
}
